import Icon from '../components/Icon';

const Filter = Icon(
  'filter',
  <>
    <path d="M15 18.25a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5zm3-7a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5zm4-7a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5z" />
  </>
);

export default Filter;
